import { FactoryProvider } from '@angular/core';
import { ApiConfig, Api } from 'bimplus-websdk';
import { BIMPLUS_API, BIMPLUS_API_CONFIG } from '@web-portal/domains/shared/bimplus-core';
import { TokenFactory, bimplusApiFactory, BIMPLUS_TOKEN_FACTORY } from '../';

export const defaultBimplusApiObjectProvider = (): FactoryProvider => ({
  provide: BIMPLUS_API,
  useFactory: (apiConfig: ApiConfig, tokenFactory: TokenFactory): Api => {
    const api = bimplusApiFactory(apiConfig);

    tokenFactory.setApi(api);
    tokenFactory.setToken();
    return api;
  },
  deps: [BIMPLUS_API_CONFIG, BIMPLUS_TOKEN_FACTORY],
});
